import { z } from 'zod'
import { ValueOf } from '@omnea-app/packages/universal/utility-types/utilityTypes'

export const TaskDistributionMethods = {
  ROUND_ROBIN: 'ROUND_ROBIN',
  ALL_USERS: 'ALL_USERS',
} as const

export type TaskDistributionMethod = ValueOf<typeof TaskDistributionMethods>

export const isTaskDistributionMethod = (method: unknown): method is TaskDistributionMethod => {
  return Object.values(TaskDistributionMethods).includes(method as TaskDistributionMethod)
}

export const TaskDistributionSchema = z.object({
  method: z.enum(TaskDistributionMethods),
})

export type TaskDistribution = z.infer<typeof TaskDistributionSchema>
